<template>
	<div class="wrapper-holiday-calendar">
		<div class="calendar-header">
			<div class="btn" @click="toPrevMonth">
				<ic-arrow :width="'12px'" :height="'24px'" :stroke="'#999999'" :rotation="0" />
			</div>
			<div class="info-month">{{ year }}년 {{ month }}월</div>
			<div class="btn" @click="toNextMonth">
				<ic-arrow :width="'12px'" :height="'24px'" :stroke="'#999999'" :rotation="180" />
			</div>
		</div>
		<div class="calendar-day">
			<div class="day-header" v-for="dayName in dayNames" :key="dayName.key">{{ dayName }}</div>
		</div>
		<div class="calendar-body">
			<date-item
				v-for="data in dates"
				:data="data"
				:key="data.fullDate"
				:tempHolidayList="tempHolidayList"
				@setHoliday="setHoliday"
			/>
		</div>
		<div class="calendar-action">
			<button @click="submit">저장</button>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import IcArrow from "./components/Arrow";
import DateItem from "./components/DateItem";

export default {
	name: "HolidayCalendar",
	components: {
		DateItem,
		IcArrow
	},
	data() {
		return {
			dayNames: ["일", "월", "화", "수", "목", "금", "토"],
			dates: [],
			selectedDay: "",
			year: null,
			month: null,
			date: null,
			day: null,
			dayFirst: null,
			dayLength: null,
			today: null,
			tempHolidayList: {
				e24Holiday: [],
				wpHoliday: [],
				e24DeliveryHoliday: []
			},
			originArr: []
		};
	},
	async created() {
		const result = await this.$store.dispatch("getHolidays");

		if (!_.isEmpty(result)) {
			this.originArr = result.slice(0);
		}

		this.initCalendar();
		this.setHolidayList();
	},
	methods: {
		// 달력 최초 생성 메소드 모음입니다.
		initCalendar() {
			this.setToday();
			this.drawCalendar();
			this.initToday();
		},

		// 오늘 날짜를 세팅해 달력 출력기준을 만듭니다.
		setToday() {
			const newDate = new Date();
			this.today = newDate;
			this.year = newDate.getFullYear();
			this.month = newDate.getMonth() + 1;
			this.date = newDate.getDate();
			this.day = newDate.getDay();
			this.dayFirst = this.day - ((this.date - 1) % 7);
			if (this.dayFirst < 0) {
				this.dayFirst += 7;
			}
		},

		// 날짜 길이와 1일의 요일 기준으로 해당 월의 달력 배열을 만듭니다.
		drawCalendar() {
			this.dayLength = this.getDaysLength();
			this.dates = [];
			for (let i = 0; i < this.dayFirst % 7; i += 1) {
				this.dates.push({});
			}
			for (let i = 1; i < this.dayLength; i += 1) {
				this.dates.push({
					fullDate: this.getFullDate(i),
					year: this.year,
					month: this.month,
					date: i
				});
			}
		},

		// 세팅된 현재 날짜 값을 string으로 변환해 넣어줍니다.
		initToday() {
			this.selectedDay = this.getFullDate(this.date);
		},
		// 현재 month 기준 날짜 길이를 리턴합니다.
		getDaysLength() {
			if (
				this.month === 4 ||
				this.month === 6 ||
				this.month === 9 ||
				this.month === 11
			) {
				return 31;
			} else if (this.month === 2) {
				if (this.year % 4 === 0) {
					if (this.year % 100 === 0) {
						if (this.year % 400 === 0) {
							return 30;
						}
						return 29;
					}
					return 30;
				}
				return 29;
			}
			return 32;
		},
		toPrevMonth() {
			this.date = null;
			if (this.month === 1) {
				this.month = 12;
				this.year -= 1;
				const prevMonthLength = this.getDaysLength() - 1;
				this.dayFirst = 7 - ((prevMonthLength - this.dayFirst) % 7);
				this.drawCalendar();
			} else {
				this.month -= 1;
				const prevMonthLength = this.getDaysLength() - 1;
				this.dayFirst = 7 - ((prevMonthLength - this.dayFirst) % 7);
				this.drawCalendar();
			}
		},
		toNextMonth() {
			this.date = null;
			if (this.month === 12) {
				this.month = 1;
				this.year += 1;
				this.dayFirst = this.dates.length % 7;
				this.drawCalendar();
			} else {
				this.month += 1;
				this.dayFirst = this.dates.length % 7;
				this.drawCalendar();
			}
		},
		numberToString(el) {
			const value = el.toString();
			if (value.length === 1) {
				return `0${value}`;
			}
			return value;
		},
		getFullDate(dateNum) {
			const month = this.numberToString(this.month);
			const date = this.numberToString(dateNum);
			const fullDate = `${this.year}-${month}-${date}`;
			return fullDate;
		},
		setHoliday(result) {
			for (let i = 0; this.originArr.length > i; i += 1) {
				if (this.originArr[i].holiday_date === result.fullDate) {
					if (result.type === "all") {
						this.originArr[i].e24 = result.value;
						this.originArr[i].e24_delivery = result.value;
						this.originArr[i].wp = result.value;
						this.originArr[i].submitState = true;
					} else {
						this.originArr[i][result.type] = result.value;
						this.originArr[i].submitState = true;
					}
					this.setHolidayList();
					return;
				}
			}
			switch (result.type) {
				case "all":
					this.originArr.push({
						holiday_date: result.fullDate,
						wp: result.value,
						e24: result.value,
						submitState: true
					});
					break;
				case "wp":
					this.originArr.push({
						holiday_date: result.fullDate,
						wp: result.value,
						e24: false,
						submitState: true
					});
					break;
				case "e24":
					this.originArr.push({
						holiday_date: result.fullDate,
						wp: false,
						e24: result.value,
						submitState: true
					});
					break;
				default:
					return;
			}

			this.setHolidayList();
		},

		setHolidayList() {
			const arr = this.originArr;
			const tempArr = {
				e24Holiday: [],
				e24DeliveryHoliday: [],
				wpHoliday: []
			};
			for (let i = 0; arr.length > i; i += 1) {
				if (arr[i].e24) {
					tempArr.e24Holiday.push(arr[i].holiday_date);
				}
				if (arr[i].e24_delivery) {
					tempArr.e24DeliveryHoliday.push(arr[i].holiday_date);
				}
				if (arr[i].wp) {
					tempArr.wpHoliday.push(arr[i].holiday_date);
				}
			}
			this.tempHolidayList = tempArr;
		},

		async submit() {
			const submitArr = [];
			this.originArr.forEach(item => {
				if (item.submitState) {
					submitArr.push({
						holiday_date: item.holiday_date,
						wp: item.wp,
						e24: item.e24,
						e24_delivery: item.e24_delivery
					});
				}
			});

			const result = await this.$store.dispatch("updateHoliday", submitArr);
			this.originArr = [];
			result.response.forEach(holiday => {
				this.originArr.push(holiday);
			});
			this.setHolidayList();
			this.$toast(result.message);
		},

		async clearDatabase() {
			await this.$store.dispatch("deleteHoliday");
		}
	}
};
</script>
<style lang="scss" scoped>
.wrapper-holiday-calendar {
	background-color: #ffffff;
}

.calendar-header {
	padding: 24px;
	@include flex(center, center);
	.info-month {
		min-width: 180px;
		font-size: 24px;
		font-weight: 700;
		color: #68b4cd;
	}
	.btn {
		width: 48px;
		height: 48px;
		border-radius: 48px;
		cursor: pointer;
		transition: all 0.3s;
		@include flex(center, center);
		&:hover {
			background-color: #ebebeb;
		}
	}
}
.calendar-body,
.calendar-day {
	display: flex;
	flex-wrap: wrap;
}
.day-header {
	font-size: 16px;
	width: calc(100% / 7);
	padding: 16px;
	@include flex(center, center);
	color: #aaaaaa;
	border-bottom: 1px solid #ebebeb;
	margin-bottom: 16px;
}
.calendar-action {
	button {
		font-size: 16px;
		padding: 12px 48px;
		margin: 24px 0px;
		border: none;
		border-radius: 24px;
		background-color: #68b4cd;
		color: #ffffff;
		font-weight: 700;
	}
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/holiday/calendar/HolidayCalendar.vue